export default __webpack_public_path__ + "static/media/team2@2x.8e4e2561.png";